<template>
	<v-row justify="center">
		<v-dialog v-if="dialog" v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>{{title}}</span>
					<span class="pl-2 font-weight-bold"></span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="data" :items-per-page="10" no-data-text="Data tidak tersedia">
						</v-data-table>
					</v-card>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			headers: [
			{ text: 'Kode Mitra', value: 'customer_network_mid'},
			{ text: 'Nama Mobile Counter', value: 'customer_name'},
			{ text: 'No Handphone', value: 'customer_mobilephone'},
			{ text: 'Alamat', value: 'customer_address'},
			],
		}
	},
	props: {
		data: Array,
		title: String,
	},
	methods :{
		showDialog() {
			this.dialog = true
		},
		hideDialog(){
			this.dialog = false
		},
	}
};
</script>
